import { createFileRoute } from "@tanstack/react-router";
import ChangelogOverview from "src/components/changelog";

export const Route = createFileRoute("/_admin/a/changelog/")({
    component: ChangelogOverview,
});
